import React from "react";

function IconMenu() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="20"
            fill="none"
            viewBox="0 0 32 20"
        >
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M0 1.5A1.1 1.1 0 011.1.4h29a1.1 1.1 0 010 2.2h-29A1.1 1.1 0 010 1.5zM0 10.1A1.1 1.1 0 011.1 9h29a1.1 1.1 0 010 2.2h-29A1.1 1.1 0 010 10.1zM0 18.1A1.1 1.1 0 011.1 17h29a1.1 1.1 0 010 2.2h-29A1.1 1.1 0 010 18.1z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default IconMenu;
